import { render, staticRenderFns } from "./SLink2.vue?vue&type=template&id=5f93c6b8&scoped=true"
import script from "./SLink2.vue?vue&type=script&lang=js"
export * from "./SLink2.vue?vue&type=script&lang=js"
import style0 from "./SLink2.vue?vue&type=style&index=0&id=5f93c6b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f93c6b8",
  null
  
)

export default component.exports